import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isOnlyOneTicketByCustomer'
})
export class IsOnlyOneTicketByCustomer implements PipeTransform {
  transform(array: string[], ticketId: string): boolean {
    return array.includes(ticketId);
  }
}